// removed by extract-text-webpack-plugin
module.exports = {"set-price-title":"set-price-title___3SYTI","set-price-text":"set-price-text___1mwtp","set-price-btn":"set-price-btn___1GaWy"};


//////////////////
// WEBPACK FOOTER
// ./src/components_business/SkusEdit/SkusTable/Index.less
// module id = Bot/
// module chunks = 10 11